import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Image, Button } from 'reaxl';
import { jsx as _jsx } from "react/jsx-runtime";
class DealerDiffCTA extends PureComponent {
  render() {
    const {
      className,
      label,
      tile,
      onDealerDiffCTAClick,
      ...rest
    } = this.props;
    if (!label || !onDealerDiffCTAClick) {
      return null;
    }
    const componentKey = 'dealerDiffCTA';
    if (tile && tile.src) {
      return /*#__PURE__*/_jsx(Image, {
        className: className,
        alt: label,
        ...rest,
        ...tile,
        height: 44,
        onClick: onDealerDiffCTAClick
      }, componentKey);
    }
    return /*#__PURE__*/_jsx(Button, {
      "data-cmp": "dealerDiffCTA",
      className: className,
      ...rest,
      onClick: onDealerDiffCTAClick,
      bsStyle: "text",
      children: label
    }, componentKey);
  }
}
export default DealerDiffCTA;